import { useDispatch } from "react-redux";
import { AppActions } from "../CommonApp/appSlice";
import { AppDispatch } from "../Store";

export default function useSnackBar() {
  const dispatch = useDispatch<AppDispatch>();
  const setSnackBar = (type: "success" | "error" | "info" | "warning", message: string) => {
    return dispatch(
      AppActions.actions.setSnackBar({
        open: true,
        type,
        message,
      })
    );
  };
  const closeSnackBar = () => {
    return dispatch(
      AppActions.actions.setSnackBar({
        open: false,
        type: "success", // default type
        message: "",
      })
    );
  };
  return { setSnackBar, closeSnackBar };
}
